import React from 'react'
import Link from 'gatsby-link'

import IndexImage from "./IndexImage.jpg"
import Glenn from "./Glenn.jpg"

const hero = {
    height: '50vh',
    position: 'relative',
    overflow: 'hidden',
    marginTop:-80
}

const IndexImageCss = {
    opacity: 0,
    width: '100%',
    height: '60%',
    objectFit: 'cover',
    objectPosition: 'center',
    position: 'fixed',
    zIndex: -10,
    transition: 'all 1s ease-in-out'
};

const button = {
    display: 'block',
    padding: '20px 40px',
    background: '#48e584',
    color: 'white',
    textDecoration: 'none',
    boxShadow: '0px 7px 20px 0px #00000036'
};

const YouTubeIds = [
    'd0ZZbuNmFas',
    'IzFNvcECyF0',
    'Y_5MW25__1Y',
    '9SmUxbjOsr0',
    'NVZOfVMOmxo',
    'Exu6EB9uMpQ',
    'nXFWFaigWeo',
    'xeMqbFoiPLI',
];

export default class extends React.Component {

    state = {
        YouTube: null,
        images: [
            IndexImage,
            'https://s3.amazonaws.com/fishfin/Boats/photo%20(5).JPG',
            'https://s3.amazonaws.com/fishfin/Cars%20&%20Bikes/DSC00899.JPG',
            'https://s3.amazonaws.com/fishfin/Diving/PIC_0181.JPG',
            'https://s3.amazonaws.com/fishfin/Hunting/pictures%201110.jpg',
            'https://s3.amazonaws.com/fishfin/Keys%20Fishing/DSC00079.JPG'
        ],
        image: 0
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            let count = (this.state.image + 1) >= this.state.images.length ? 0 : this.state.image + 1;
            this.setState({image: count})
        }, 4500)
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return <div/>
        return (<div>

          {this.state.YouTube?<div style={{
            position:'fixed',left:0,right:0,bottom:0,top:0,backgroundColor:'rgba(0,0,0,.3)',zIndex:999,
            display: 'flex', justifyContent: 'center', flexDirection: 'column'
          }} onClick={()=>this.setState({YouTube:null})}>
              <iframe style={{margin:'0 auto'}} width="560" height="315" src={`https://www.youtube.com/embed/${this.state.YouTube}`} frameborder="0" allow="autoplay; encrypted-media" allowfullscreen/>
          </div>:null}

            <div style={hero}>
                {this.state.images.map((image, index) => <img id="banner" src={image}
                                                              style={{
                                                                  ...IndexImageCss,
                                                                  opacity: this.state.image === index ? 1 : 0
                                                              }}/>)}
            </div>
            <div style={{background: '#fff', visibility: 0}} className="animated slideInUp">
                <div style={{
                    margin: '0 auto',
                    maxWidth: 600,
                    padding: '1.45rem 1.0875rem'
                }}>
                    <img src={Glenn} alt="Glenn @ fishfin" className="animated slideInLeft" style={{
                        borderRadius: '50%',
                        width: 200,
                        height: 200,
                        objectFit: 'cover',
                        float: 'left',
                        marginLeft: -20,
                        marginRight: 20,
                        boxShadow: '0px 7px 20px 0px #00000036'
                    }}/>
                    <p style={{minWidth: 200}}>
                        <em style={{fontSize: '1.2em', fontWeight: 800}}>Fishfin</em> is a site dedicated to embracing
                        the
                        Floridian lifestyle. Our friends and family
                        enjoy fishing in the Manatee River, Sarasota Bay and Tampa Bay on the southwest
                        coast and Miami, Key Largo, Islamorada and the Bahamas on the east coast. Our
                        other recreational activities include hunting hogs and scuba diving.</p>
                    <p>Before moving to Florida we fished for Striped Bass and dove in the cold waters of
                        Massachusetts and New Jersey.</p>
                    <p>This is our website, gallery, fishing log and links to some great guides and friends
                        who enjoy similar interests her in the Sunshine State. A special thanks to “Justin”
                        for creating this site for me allowing us to share our passion with you. Hope you
                        like it.</p>
                    <Link style={button} className="bounceClick" to="/gallery/">Check Out Our Gallery
                        <span>&#10230;</span></Link>

                    <div style={{display:'flex',marginTop:20,width:'100%',overflowY:'scroll'}}>
                      {YouTubeIds.map(id=><img onClick={()=>this.setState({YouTube:id})} src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} height={150} style={{objectFit:'cover',margin:20}}/>)}
                    </div>

                </div>
            </div>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/pages/index.js